var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "texture" },
    [
      _c("label", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c("div", { staticClass: "textures_toggle" }, [
        _c(
          "div",
          {
            staticClass: "texture__btn",
            on: {
              click: function($event) {
                _vm.showList = !_vm.showList
              }
            }
          },
          [
            _vm.selectedTexture
              ? _c("img", { attrs: { src: _vm.selectedTexture, alt: "" } })
              : _c("span")
          ]
        ),
        _vm._v(" "),
        _vm.showList
          ? _c(
              "ul",
              { staticClass: "texture__list" },
              [
                _c(
                  "li",
                  {
                    staticClass: "default__texture",
                    on: {
                      click: function($event) {
                        return _vm.select(null)
                      }
                    }
                  },
                  [_c("span")]
                ),
                _vm._v(" "),
                _vm._l(_vm.textures, function(texture, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      on: {
                        click: function($event) {
                          return _vm.select(texture)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: texture, alt: "", srcset: "" }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "add__texture", on: { click: _vm.uplaod } },
                  [_c("i", { staticClass: "fas fa-upload" })]
                )
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("Upload", {
        ref: "uploader",
        staticClass: "upload",
        attrs: { type: "image", accptedFormat: ["jpg", "png", "jpeg"] },
        on: { input: _vm.getTexture }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bc80ce6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc80ce6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/TexturePicker.vue
// module id = null
// module chunks = 